import type { Maybe } from '~/schema/types/generated'

export default function isArrayNotNull<T>(arr: Maybe<T>[]): T[] {
    return arr.filter((item) => !!item) as unknown as T[]
}
